import * as React from 'react';
import { PropsWithChildren, useCallback, useMemo, useState } from 'react';
import { useKeyPress } from '../hooks/useKeyPress';
import { ImageViewWidget } from './layout/ImageViewWidget';

export const LightboxContext = React.createContext({
  setImage: (src: string) => {}
});

export const LightboxWrapper: React.FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const [img, setImage] = useState<string>();

  const clearImage = useCallback(() => {
    setImage(() => null);
  }, []);

  const contextProps = useMemo(
    () => ({
      setImage: setImage
    }),
    []
  );

  const onEscPress = useCallback(
    (ev: KeyboardEvent) => {
      ev.preventDefault();
      clearImage();
    },
    [clearImage]
  );

  useKeyPress('Escape', !!img ? onEscPress : null);

  return (
    <LightboxContext.Provider value={contextProps}>
      {children}
      {!!img && <ImageViewWidget img={img} close={clearImage} />}
    </LightboxContext.Provider>
  );
};
